import type { ClassValue } from 'clsx';

import { clsxm } from '@vs-shop/utils';

import HomepageTaxonNavigationItem from '../../../client/page/homepage/HomepageTaxonNavigationItem';

import type { HomepageTaxon } from '../../../../effect/schema/openapi/backend';

type Props = {
  taxons: readonly HomepageTaxon[];
  selectedTaxon: HomepageTaxon | null;
  onSelectTaxon: (taxon: HomepageTaxon) => void;
  className?: ClassValue;
};

export default function HomepageTaxonNavigation({
  taxons,
  selectedTaxon,
  onSelectTaxon,
  className,
}: Props) {
  return (
    <ul className={clsxm('flex gap-8 lap-lg:gap-16', className)} data-slot="homepage-taxon-tabs">
      {taxons.map((taxon) => {
        return (
          <li key={taxon.code}>
            <HomepageTaxonNavigationItem
              taxon={taxon}
              isCurrent={selectedTaxon?.code === taxon.code}
              onSelect={onSelectTaxon}
            />
          </li>
        );
      })}
    </ul>
  );
}
